module.exports = "/_next/static/images/expired-crossborder-d00fdb84cceacaf4fce627bfb20505f0.svg";